import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import Header from "./header";

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";

import "react-accessible-accordion/dist/fancy-example.css";

const chevronLeft = <FontAwesomeIcon icon={faChevronLeft} />;
const contactInfo = (
  <div>
    <p>Work directly with your manager or contact the Support team.</p>
  </div>
);

const content = [
  {
    id: 1,
    question: "What is this Tool?",
    answer:
      "A new tool has been created to allow you to more easily determine proper Product and Sub Codes for your items.",
  },
  {
    id: 2,
    question: "What do I access this tool?",
    answer: "The tool can be found at: XXXXXXXXX",
  },
  {
    id: 3,
    question: "What do I need to do to review an item?",
    answer:
      "Identify the type of form in which you are classifying, once you have identified the Product Code – Both Major and Minor you will log into TCOMS/Item Maintenance, locate your item, then update the Product Code and Sub Code if needed. ",
  },
  {
    id: 4,
    question: "Why is important to review items and update them?",
    answer:
      "To ensure revenue is flowing to the right Business Units, you are being asked to ensure that items are being established correctly. The BU leaders have worked hard to provide more accurate Product Codes for both you, them and manufacturing. \n\n Data and Revenue integrity is a key component of any company.",
  },
  {
    id: 5,
    question: "When do I need to review an item?",
    answer:
      "The most critical time to review an item is when you are establishing the item or adjusting specs on the item. However, at any point prior to ordering item, you should follow the instructions above and review items to ensure product codes are properly mapped. ",
  },
  {
    id: 6,
    question: "Do I have to use the tool?",
    answer:
      "While it is not required that you utilize the tool it is highly recommended that the tool is used for a period of time to associate you with the new product codes that have been established for your products. ",
  },
  {
    id: 7,
    question:
      "Who do I go to if I need assistance with an item that I think might need to be updated, but I can't figure it out by utilizing the tool?",
    answer: contactInfo,
  },
];

function Tabs(props) {
  const content = props.items.map((item) => (
    <AccordionItem key={item.id}>
      <AccordionItemHeading>
        <AccordionItemButton>{item.question}</AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
        <div className="new-line">{item.answer}</div>
      </AccordionItemPanel>
    </AccordionItem>
  ));
  return <Accordion>{content}</Accordion>;
}

function Faq() {
  return (
    <div className="layout">
      <Header />
      <div className="content">
        <div className="animate__animated animate__fadeIn category">
          <div className="group">
            <h3>FAQ</h3>
            <div className="row credit-items">
              <div className="col">
                <Tabs items={content} />
              </div>
            </div>
          </div>
          <div className="navigation">
            <div className="row">
              <div className="col prev">
                <Link to="/guide">
                  {chevronLeft}
                  {"Guide"}
                </Link>
              </div>
              <div className="col next"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Faq;
